import { observer } from 'mobx-react-lite'
import { ConsultationModal } from '@/features/opportunities/ConsultationModal'
import { type ConsultationModalViewModel } from './ConsultationModalViewModel'

export interface ConsultationModalContainerProps {
  vm: ConsultationModalViewModel
}

export const ConsultationModalContainer = observer(
  function ConsultationModalContainer({ vm }: ConsultationModalContainerProps) {
    return (
      <ConsultationModal
        showing={vm.modal.showing}
        onClose={vm.close}
        onSubmit={vm.submit}
        requestedLength={vm.requestedLength}
        client={vm.clientAvatar}
        currentMember={vm.currentMemberAvatar}
        days={vm.days}
      />
    )
  },
)
